import React, { useEffect, useState } from 'react';
/* import { NavLink } from 'react-router-dom'; */
import axios from 'axios';
import { useAuth } from '../AuthContext';
import DOMPurify from 'dompurify';

export default function EditProfile() {
    const apiKey = process.env.REACT_APP_API_KEY;
    const baseURL = process.env.REACT_APP_BASE_URL;
    const [stateData, setStateData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [agegroupData, setAgegroupData] = useState([]);
    const [genderData, setGenderData] = useState([]);
    const userId = localStorage.getItem('userid');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { edit_profile } = useAuth();

    const [formData, setFormData] = useState({

        name: '',
        genderid: 0,
        phonenumber: '',
        stateid: 0,
        districtid: 0,
        agegroupid: 0,
        school_name: '',
        zipcode: '',
        udise: '',
        userid: userId,
        is_profile_completed: true,
        user_source: "Web",
        
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        const url = `${baseURL}/editprofile/`;
        const headers = {
            'accept': 'application/json',
            'Authorization': apiKey,
            'Content-Type': 'application/json'
        };

        try {
            await axios.post(url, formData, { headers });

            localStorage.setItem('ageGroupID', formData.agegroupid);
            setIsModalOpen(true);
            // alert('Registration successful!');
            edit_profile();
            window.location.href = "/home";

        } catch (error) {
            console.error('Error:', error.response ? error.response.data : error.message);

            alert('Registration unsuccessful!');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = DOMPurify.sanitize(value);
        if (name === "zipcode") {
            if (sanitizedValue.length > 6) return;
        }
        setFormData({ ...formData, [name]: sanitizedValue });
    };

    const handleValueChange = (e) => {
        const input = e.target.value;
        const sanitizedInput = DOMPurify.sanitize(input.replace(/\D/g, '').slice(0, 10));
        setFormData(prevFormData => ({ ...prevFormData, phonenumber: sanitizedInput }));
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${baseURL}/basicdata/?userid=${userId}`, {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': apiKey
                    }
                });

                setStateData(response.data.states_data);
                setDistrictData(response.data.districts_data);
                setAgegroupData(response.data.agegroup_data);
                setGenderData(response.data.genders_data);

            } catch (error) {
                console.error('Error fetching data:', error);

            }
        };

        if (userId) {
            fetchData();
        }
    }, [userId, baseURL, apiKey]);

    const handleChange1 = (e) => {
        const { name, value } = e.target;
        const sanitizedValue = DOMPurify.sanitize(value);

        if (name === 'stateid') {

            const selectedState = stateData.find(state => state._id === parseInt(sanitizedValue));


            const filteredDistricts = districtData.filter(district => district.stateid === selectedState._id);


            setFormData({
                ...formData,
                [name]: parseInt(sanitizedValue),
                districtid: filteredDistricts.length > 0 ? filteredDistricts[0]._id : 0,
            });
        } else {

            setFormData({
                ...formData,
                [name]: sanitizedValue,
            });
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
        window.location.href = "/home"; // Redirect to home after closing the modal
    };




    return (
        <>

            <div className='outer-layr'></div>
            <section className="profile-part">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="account-card">
                                <div className="account-title">
                                    <h4>Complete Your Profile</h4>

                                </div>
                                <div className="account-content">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">

                                            <div className="col-md-6 col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor='fname'>name</label>
                                                    <input id='fname' className="form-control" type="text" name="name" value={formData.name} onChange={handleChange} placeholder="name" required />
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-4">
                                                <div className="form-group" htmlFor="gender">
                                                    <label id='gender' className="form-label">Gender</label>
                                                    <select className="form-control" name="genderid" value={formData.genderid} onChange={handleChange} required>
                                                        <option value="">Select Gender</option>

                                                        {genderData.map(gender => (
                                                            <option key={gender._id} value={gender._id} >{gender.gender}</option>
                                                        ))}
                                                    </select>

                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="phnumber">Phone Number</label>
                                                    <input id="phnumber" className="form-control" type="tel" name="phonenumber" value={formData.phonenumber} onChange={handleValueChange} placeholder="Phone Number (Optional)" maxLength="10" />
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="age">Age Group</label>
                                                    <select id='age' className="form-control" name="agegroupid" value={formData.agegroupid} onChange={handleChange} required>
                                                        <option value="" >Select Age Group</option>

                                                        {agegroupData.map(agegroups => (
                                                            <option key={agegroups._id} value={agegroups._id} >{agegroups.agegroup}</option>
                                                        ))}
                                                    </select>

                                                </div>
                                            </div>

                                            <div className="col-md-6 col-lg-4">


                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="statename">State</label>
                                                    <select id='statename' className="form-control" name="stateid" value={formData.stateid} onChange={handleChange1} required>
                                                        <option value="">Select State</option>
                                                        {stateData.map(state => (
                                                            <option key={state._id} value={state._id} id={state._id}>{state.statename}</option>
                                                        ))}
                                                    </select>
                                                </div>




                                            </div>
                                            <div className="col-md-6 col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor="district">District</label>
                                                    <select
                                                        id='district'
                                                        className="form-control dropdown-arrow"
                                                        name="districtid"
                                                        value={formData.districtid}
                                                        onChange={handleChange1}
                                                        required
                                                        disabled={formData.stateid === 0} // Disable if stateid is 0 (default)
                                                    >

                                                        {districtData.map(district => (
                                                            district.stateid === formData.stateid && (
                                                                <option key={district._id} value={district._id}>{district.districtname}</option>
                                                            )
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor='zipcode'>Zip Code</label>
                                                    <input id='zipcode' className="form-control" type="number" name="zipcode" value={formData.zipcode} onChange={handleChange} placeholder="Zip Code" maxLength="6" required />
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor='udsie'>School UDISE</label>
                                                    <input id='udsie' className="form-control" type="text" name="udise" value={formData.udise} onChange={handleChange} placeholder="School UDISE (Optional)" />
                                                </div>
                                            </div>
                                            <div className="col-md-6 col-lg-4">
                                                <div className="form-group">
                                                    <label className="form-label" htmlFor='scname'>School Name</label>
                                                    <input id='scname' className="form-control" type="text" name="school_name" value={formData.school_name} onChange={handleChange} placeholder="School Name (Optional)" />
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="section-btn-25">
                                                    <button className="btn-6 view-all-btnn">
                                                        Submit
                                                    </button>
                                                </div>
                                            </div>

                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                <div className="modal fade set-md-width" id="profile-update" tabindex="-1" aria-labelledby="profile-update" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <button className="modal-close icofont-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <div className="modal-body">
                                <div className='row justify-content-center'>
                                    <div className='col-md-10'>

                                        <div className="user-form-title">
                                            <h2>Profile Updated Sucessfuly</h2>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



                {isModalOpen && (
                    <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="profile-update" aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                            <div className="modal-content">
                                <button
                                    type="button"
                                    className="modal-close icofont-close"
                                    onClick={closeModal}
                                    aria-label="Close"
                                ></button>
                                <div className="modal-body">
                                    <div className="user-form-title text-center">
                                        <h2>Registration successful!</h2>
                                    </div>
                                    <div className="text-center mt-3">
                                        <button
                                            className="btn btn-primary"
                                            onClick={closeModal}
                                        >
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </section>
        </>
    )
}
